/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903493146 — CarWashScreen */

import { useTranslation } from 'react-i18next';

import { ContentBox, ErrorText, Input, InputWrapper, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { useLoyaltyStore } from '../../../loyalty';
import { useOrderActions } from '../../../order/hooks/useOrderActions';
import { withOrderHydration } from '../../../order/hooks/withOrderHydration';
import { PaymentOrFeedback } from '../../components/PaymentOrFeedback/PaymentOrFeedback';
import { useTimerTimeout } from '../../hooks/useTimerTimeout';
import { useVolumeOptions } from '../../hooks/useVolumeOptions';
import { LIMITS } from '../../payment.constants';
import {
    defaultCarWashPricePerUnit,
    defaultCarWashVolumes,
} from './CarWashScreen.data';
import { VolumeOptionsList } from './components';

import { PriceWithPlanogram } from '../../components/PriceDisplay/PriceWithPlanogram/PriceWithPlanogram';
import style from './CarWashScreen.module.css';

const CAR_WASH_LIMITS = LIMITS.CAR_WASH;

const CarWashScreenBody = () => {
    const { t } = useTranslation();
    const { onTimerTimeoutHandler } = useOrderActions();

    const {
        amount: amountInSubunits,
        originalAmount: originalAmountSubunits,
        isAmountSent,
        customVolume,
        isPaymentButtonVisible,
        volume,
        volumeError,
        availableVolumes,
        cheapestVolume,
        isCheapestSelected,
        selectVolumeOption,
        onCustomVolumeChange,
    } = useVolumeOptions(
        CAR_WASH_LIMITS,
        defaultCarWashVolumes,
        defaultCarWashPricePerUnit,
        { usePlanogramVolumes: true, screenName: 'car-wash' },
    );

    const isPrizeAvailable = useLoyaltyStore((s) => s.isPrizeAvailable());

    useTimerTimeout({
        screenName: 'car-wash',
        onTimeout: () => onTimerTimeoutHandler('car-wash'),
    });

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('car-wash.enterAmount')}</ScreenTitle>
            <ContentBox>
                <VolumeOptionsList
                    availableVolumes={availableVolumes}
                    currentVolume={volume}
                    volumeSymbol={t('Currency.UAH')}
                    onSelect={selectVolumeOption}
                    loyaltyVolume={isPrizeAvailable ? cheapestVolume : null}
                />
                <InputWrapper>
                    <Input
                        type="number"
                        placeholder={t<string>('car-wash.enterAmount')}
                        value={customVolume && customVolume > 0 ? customVolume : ''}
                        min={CAR_WASH_LIMITS.MIN}
                        onChange={onCustomVolumeChange}
                    />
                    <ErrorText>{volumeError}</ErrorText>
                </InputWrapper>
                <PriceWithPlanogram
                    className={style.priceWrapper}
                    amountInSubunits={amountInSubunits}
                    originalAmountSubunits={originalAmountSubunits}
                />
                <PaymentOrFeedback
                    isVisible={isPaymentButtonVisible && isAmountSent}
                    isLoyaltyEligible={isCheapestSelected}
                    screenName="car-wash"
                />
            </ContentBox>
        </ScreenWrapper>
    );
};

const CarWashScreen = withOrderHydration(CarWashScreenBody);

export { CarWashScreen };
